import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DeviceParamaters } from "../actions/apiActions";

export const devicesParametersDefaultState = {
  selectedDevicesParameters: []
};

const formatParameterList = (allParamatersForOneDevice) => {

  const countDecimals = (value) => {
    if (Math.floor(value) === value) return 0;
    return value.toString().split(".")[1].length || 0;
  };

  let formattedList = [];
  allParamatersForOneDevice.map((object) => {
    let formattedObject = { ...object };
    if ((object.type === "numeric") && (!object.value === null)) {
      formattedObject.floatPrecision = countDecimals(object.value);
    } else {
      formattedObject.floatPrecision = 0;
    }
    if (object.value === null) {
      formattedObject.value = "";
    }
    formattedObject.displayName = object.parameterName.replace(/([A-Z])/g, ' $1').trim();
    formattedList.push(formattedObject);
  });

  return formattedList;
};


export const getAllParametersForDevice = createAsyncThunk(
  "devicesParameters/getAllParametersForDevice",
  async (params, thunk) => {
    const { systemId, hwId, isSensor } = params;
    const { config } = thunk.getState().config[systemId].system;
    if (config) {
      const payload =
        {
          customerId: config.CUSTOMER_ID,
          deviceId: config.DEVICE_ID,
          hwId: hwId,
          isSensor: isSensor
        } || {};
      const response = await DeviceParamaters.get(config.DATA_URL, payload);
      const formattedResponse = formatParameterList(response);
      return { formattedResponse, systemId };
    }
  }
);


const devicesParametersSlice = createSlice({
  name: "devicesParameters",
  initialState: devicesParametersDefaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllParametersForDevice.fulfilled, (state, action) => {
        const data = action.payload.formattedResponse;
        state.selectedDevicesParameters = data;
      });
  },
});

export const { } = devicesParametersSlice.actions;

export default devicesParametersSlice.reducer;
